/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_Labels_Show_On_PageInputs */

const en_reading_labels_show_on_page = /** @type {(inputs: Reading_Labels_Show_On_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show labels on page`)
};

const es_reading_labels_show_on_page = /** @type {(inputs: Reading_Labels_Show_On_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar etiquetas en la página`)
};

/**
* | output |
* | --- |
* | "Show labels on page" |
*
* @param {Reading_Labels_Show_On_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const reading_labels_show_on_page = /** @type {((inputs?: Reading_Labels_Show_On_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_Labels_Show_On_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_reading_labels_show_on_page(inputs)
	return en_reading_labels_show_on_page(inputs)
});